<app-page headline="Inventory">
  <div stack-layout [fullWidth]="true" alignItems="center" gap="md">
    <div row-layout gap="md" [fullWidth]="true">
      <div
        stack-layout
        borderRadius="xs"
        border="light"
        paddingHorizontal="lg"
        paddingVertical="md"
        gap="md"
        alignItems="center"
        [minWidth]="300"
        [fullWidth]="true"
        elevation="raised"
      >
        <Text role="headline-small"> Download Inventory Data </Text>

        <div stack-layout [fullWidth]="true" paddingBottom="md">
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">WMS</Text>
          </div>
          <app-select
            [options]="syncOptions()"
            [form]="downloadForm"
            controlName="warehouseManagementSystem"
          />
        </div>

        <app-download-button
          mode="text"
          [blobObservable]="inventoryService.downloadInventory(selectedWms())"
          [downloadFileName]="getInventoryDownloadFilename()"
        />
      </div>

      @if (permissionToSync()) {
        <div
          stack-layout
          borderRadius="xs"
          border="light"
          paddingHorizontal="lg"
          paddingVertical="md"
          gap="md"
          alignItems="center"
          [minWidth]="300"
          [fullWidth]="true"
          elevation="raised"
        >
          <Text role="headline-small"> Sync Data To Sales Portal </Text>

          <div stack-layout [fullWidth]="true" paddingBottom="md">
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">WMS</Text>
            </div>
            <app-select
              [options]="syncOptions()"
              [form]="syncForm"
              controlName="warehouseManagementSystem"
            />
          </div>

          <button text-button size="md" (click)="syncData()">Sync</button>
        </div>

        <div
          stack-layout
          borderRadius="xs"
          border="light"
          paddingHorizontal="lg"
          paddingVertical="md"
          gap="md"
          alignItems="center"
          [minWidth]="300"
          [fullWidth]="true"
          elevation="raised"
        >
          <Text role="headline-small"> Sync Data To Sales Channel </Text>

          <div stack-layout [fullWidth]="true" paddingBottom="md">
            <div box-layout paddingLeft="sm">
              <Text role="headline-small">Sales Channel</Text>
            </div>
            <app-select
              [options]="salesChannelOptions()"
              [form]="syncSalesChannelForm"
              controlName="salesChannelCode"
              [disableWhenNoOptions]="false"
              [placeholder]="salesChannelPlaceholder()"
            />
          </div>

          <button
            text-button
            size="md"
            (click)="syncSalesChannelData()"
            [disable]="!selectedSyncSalesChannel()"
          >
            Sync
          </button>
        </div>
      }
    </div>

    <div box-layout [grow]="1" [fullWidth]="true">
      @if (inventoryService.noDataSyncHistory()) {
        <div center-layout [grow]="1" [fullWidth]="true">
          <Text role="title-large">No inventory sync history.</Text>
        </div>
      }

      <app-log-table
        [datasource]="dataSyncHistoryDatasource"
        label="Sales Portal Sync History"
        [loading]="inventoryService.dataSyncHistory.isLoading()"
        (reload)="inventoryService.dataSyncHistory.reload()"
      />

      <div box-layout paddingTop="lg"></div>

      <app-log-table
        [datasource]="salesChannelSyncHistoryDatasource"
        label="Sales Channel Sync History"
        [loading]="inventoryService.salesChannelSyncHistory.isLoading()"
        (reload)="inventoryService.salesChannelSyncHistory.reload()"
      />
    </div>
  </div>
</app-page>
